export const STORE = "LANDING";
export const GET_TAB_ACTIVE = "GET_TAB_ACTIVE";
export const SET_TAB_ACTIVE = "SET_TAB_ACTIVE";
